export default __webpack_public_path__ + "static/media/lost-166fcc89.528d0dd3.png";